import { useQuery } from '@tanstack/react-query';
import { queryKeys, unwrap, type components } from '@geefamily/api';
import { api } from '@/app/api';

export type StreamerProfile = components['schemas']['StreamerProfileResponse'];
export type SocialLink = components['schemas']['SocialLinkResponse'];

export const streamerKeys = queryKeys.module('content').entity('streamer');

/**
 * The streamer card's content.
 *
 * From the API rather than build-time configuration, because the LIVE badge is
 * switched several times a week and a `VITE_` variable cannot change without a
 * redeploy. The bio and socials came with it so the card is edited in one place.
 */
export function useStreamerProfile() {
  return useQuery({
    queryKey: streamerKeys.all,
    queryFn: () => unwrap<StreamerProfile>(api.GET('/api/v1/content/streamer', {})),
    // Short: the server already caches this for five minutes, and the one field
    // that changes on its own — whether the stream is on — is the whole reason
    // anybody reloads the page.
    staleTime: 60_000,
  });
}
